<template>
    <div class="text-subtitle-1 pb-3">{{ $t('contract_tags_title') }}</div>
    <v-checkbox
        v-model="formData.ignoreTagsSettingsForTO1"
        hide-details
        :label="$t('ignore_settings_for_to1')"
        data-cy="ignore-settings-for-to1"
        class="pb-3"
    />
    <div class="text-subtitle-1">{{ $t('contract_offered_tags_title') }}:</div>
    <v-row no-gutters>
        <v-col cols="12" md="6">
            <v-textarea v-model="formData.requestedTags" rows="2" data-cy="requested-tags" />
        </v-col>
    </v-row>
    <div class="text-subtitle-1">{{ $t('contract_not_offered_tags_title') }}:</div>
    <v-row no-gutters>
        <v-col cols="12" md="6">
            <v-textarea v-model="formData.excludedTags" rows="2" data-cy="excluded-tags" />
        </v-col>
    </v-row>
</template>
<script setup lang="ts">
    const formData = defineModel<any>()
</script>
